import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './scss/style.scss';
import MainLayout from './components/MainLayout';
import ProtectedRoute from './components/ProtectedRoute';
import { ParallaxProvider } from 'react-scroll-parallax';
import { InterviewProvider } from './context/InterviewContext';

import Home from './pages/Home';
import TalentForm from './pages/TalentForm';
import ThankYou from './pages/ThankYou';
import PageNotFound from './pages/PageNotFound';
import TermService from './pages/TermService';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Login from './pages/Login';
import Register from './pages/Register';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import JobList from './pages/JobList';
import StatusLamaran from './pages/StatusLamaran';
import JobDetail from './pages/JobDetail';
import InterviewEntry from './pages/InterviewEntry';
import InterviewSession from './pages/InterviewSession';
import InterviewResult from './pages/InterviewResult';
import InterviewDetail from './pages/InterviewDetail';
import Profile from './pages/Profile';

function App() {
    return (
        <ParallaxProvider>
            <InterviewProvider>
                <BrowserRouter>
                    <Routes>
                        <Route element={<MainLayout />}>
                            <Route path='/' element={<Home/>}/>
                            {/* <Route path='/talent' element={<Talent/>}/> */}
                            <Route path='/form-talent/:jobId' element={<ProtectedRoute element={<TalentForm/>}/>}/>
                            <Route path='/lowongan-kerja' element={<JobList/>}/>
                            <Route path='/status-lamaran' element={<ProtectedRoute element={<StatusLamaran/>}/>}/>
                            <Route path='/lowongan-kerja/:id' element={<JobDetail/>}/>
                            <Route path='/terima-kasih' element={<ThankYou/>}/>
                            <Route path='/ketentuan-layanan' element={<TermService/>}/>
                            <Route path='/kebijakan-privasi' element={<PrivacyPolicy/>}/>
                            <Route path='*' element={<PageNotFound/>}/>
                            <Route path='/login' element={<Login/>}/>
                            <Route path='/register' element={<Register/>}/>
                            <Route path='/forgot-password' element={<ForgotPassword/>}/>
                            <Route path='/reset-password' element={<ResetPassword/>}/>
                            <Route path='/interview/:jobId' element={<ProtectedRoute element={<InterviewEntry/>}/>}/>
                            <Route path='/interview/session/:jobId' element={<ProtectedRoute element={<InterviewSession/>}/>}/>
                            <Route path='/interview/result/:jobId' element={<ProtectedRoute element={<InterviewResult/>}/>}/>
                            <Route path='/interview/detail/:jobId' element={<ProtectedRoute element={<InterviewDetail/>}/>}/>
                            <Route path='/profil' element={<ProtectedRoute element={<Profile/>}/>}/>
                        </Route>
                    </Routes>
                </BrowserRouter>
            </InterviewProvider>
        </ParallaxProvider>
    )
}

export default App;
